import React from "react";

const RubbingCarWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">
          Exterior Paint Restoration & Shine Enhancement (Rubbing & Polish)
        </p>
        <ul className="list-disc text-black-500">
          <li>Exterior Rubbing Compound Treatment</li>
          <li>Removes Minor Scratches & Swirl Marks</li>
          <li>Restores Original Paint Gloss</li>
          <li>Exterior Foam Wash After Rubbing</li>
          <li>Surface Ready for Wax/Coating</li>
          <li>Tyre & Bumper Polish</li>
          <li>
            <b>
              Cleaning under the bonnet is at the owner's risk. Not recommended
              (₹100 extra).
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RubbingCarWash;
